/**
 * The session artifact-window vocabulary (`TabType`).
 *
 * Same treatment as `StreamingStatus` and `ChunkStatus`: the leaf vocabulary
 * moves here, the declaring app module re-exports it name-intact, and enum
 * identity is preserved for every existing importer. What moves is the
 * VOCABULARY only — the tabs registry, `sessionWindowsAtoms` and the window
 * composition hooks are session UI state and stay app-side until the Wave-4
 * session assembly (README D2g).
 *
 * WHY THE VOCABULARY COULD NOT WAIT FOR THAT ASSEMBLY. `TabType` was declared
 * in an app module no CODEOWNERS row matched, and read from three other
 * domains: the Work composer's artifact router names the tab it focuses
 * (`focusTab`), and the agent workspace snapshot sent to ml-scribe names the
 * tab the user is looking at (`active_tab`). Both are protocol — one a
 * navigation intent, one a wire field — so both were reaching an app-shell
 * module one hop further out than the request body naming them, and neither
 * could cross a package boundary while the enum had no door. Sitting in
 * `/contracts` it is what it always was, a closed set of window labels, and it
 * costs this package nothing: zero imports, no app coupling, no side effect.
 *
 * THE VALUES ARE WIRE. `active_tab` is sent to ml-scribe and the labels are
 * compared as raw strings across the app, so they are frozen by
 * `types.frozen.test.ts` against literals — if that assertion fails, restore
 * the value rather than updating the test.
 */
export enum TabType {
  CONTEXT = 'context',
  NOTE = 'note',
  TRANSCRIPT = 'transcript',
  DOCUMENT = 'document',
  LETTER = 'letter',
  RESEARCH_NOTE = 'research_note',
  SESSION_MERGE = 'session_merge',
  PRECHART = 'prechart',
}
